module.exports = __webpack_public_path__ + "static/media/5 1 Leseforstaelse Intro.f16edb9a.mp3";